const hostApi = process.env.NODE_ENV === "development" ? "https://be.sibakti.mysurvey.id" : "https://be.sibakti.mysurvey.id";
const portApi = process.env.NODE_ENV === "development" ? 3030 : "3010";

const baseURLApi = `${hostApi}`;

//import loginData from "../pages/Login/Login"

export default {
    hostApi,
    portApi,
    baseURLApi,
}